import React, { useContext, useState } from 'react';
import './SharingContainer.style.css';

import { CSVLink } from 'react-csv';
import {
	Dialog,
	Button,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from '@material-ui/core';

import { FilterContext } from '../../contexts/FilterContext';
import {
	handleDownloadRawFreqCSV,
	handleDownloadTrendlineCSV,
	handleEmbeddedUrl,
	handleSharingClick,
	handleSVGDownload,
} from './SharingContainer.utils';
export interface SharingContainerProps {
	isFilterContainerHidden?: boolean;
	graphData: { key: string; values: { x: string; y: number }[] }[];
	rawFrequencyData: { x: string; y: number }[];
	setIsModalShown: (isModalShown: boolean) => void;
	isModalShown: boolean;
}

const SharingContainer: React.FC<SharingContainerProps> = ({
	isFilterContainerHidden,
	graphData,
	rawFrequencyData,
	setIsModalShown,
	isModalShown,
}) => {
	const [isCopyModalShown, setIsCopyModalShown] = useState(false);
	const [filters] = useContext(FilterContext);
	const { graphViewmode, yearSpan } = filters;
	const hasData = graphData.length > 0 || rawFrequencyData.length > 0;

	return (
		<div
			className={`sharing-container ${
				isFilterContainerHidden && 'filters-hidden'
			}`}
		>
			<div className="link-list">
				<h2 className="title">Del dette n-grammet</h2>
				{graphViewmode !== 'galakser' && (
					<button
						onClick={() => setIsModalShown(true)}
						className="sharing-link"
					>
						Del som embed-kode
					</button>
				)}
				<button
					className="sharing-link"
					onClick={() => {
						handleSharingClick();
						setIsCopyModalShown(true);
						setTimeout(() => {
							setIsCopyModalShown(false);
						}, 1500);
					}}
				>
					{isCopyModalShown
						? 'Lenken ble kopiert til utklippstavlen.'
						: 'Kopier lenken til n-grammet til utklippstavlen'}
				</button>
			</div>
			<div className="link-list">
				<h2 className="title">Last ned materiale</h2>
				{hasData && graphViewmode !== 'galakser' && (
					<CSVLink
						data={
							graphViewmode === 'trendlinjer'
								? handleDownloadTrendlineCSV(
										graphData,
										yearSpan,
								  )
								: handleDownloadRawFreqCSV(rawFrequencyData)
						}
						separator={','}
						target="_blank"
						filename={'n-gram-data.csv'}
						className="sharing-link download"
					>
						Rådata for dette n-grammet
					</CSVLink>
				)}

				{graphViewmode !== 'galakser' && (
					<button
						onClick={handleSVGDownload}
						className="sharing-link download"
					>
						Grafikken til dette n-grammet i .svg-format
					</button>
				)}
				<a
					href="https://www.nb.no/sprakbanken/ressurskatalog/oai-nb-no-sbr-76/"
					target="_blank"
					className="sharing-link download"
					rel="noreferrer"
				>
					Korpuset i sin helhet
				</a>
			</div>
			<Dialog
				open={isModalShown}
				onClose={() => setIsModalShown(false)}
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title" color="#ff">
					Del grafen som embed-kode
				</DialogTitle>
				<DialogContent>
					<DialogContentText>
						Nedenfor ser du en forhåndsvisning av grafen din slik
						den vil se ut embeddet. Grafen huses i en iframe som
						peker tilbake til Nasjonalbiblioteket.
					</DialogContentText>
				</DialogContent>
				<iframe
					title="embedded-graph"
					src={handleEmbeddedUrl()}
					frameBorder="0"
					style={{ width: '100%', height: '476px' }}
				></iframe>
				<DialogActions>
					<Button
						onClick={() => setIsModalShown(false)}
						color="primary"
					>
						Lukk
					</Button>
					<Button
						onClick={() => {
							navigator.clipboard.writeText(
								`<iframe src="${handleEmbeddedUrl()}" frameBorder="0" style="width: 100%; height: 476px;"></iframe>`,
							);
							setIsModalShown(false);
						}}
						color="primary"
					>
						Kopier koden til utklippstavlen og lukk
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default SharingContainer;
